// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"49e0a0e5","622":"b286f3b6","977":"af0bdce4"}[chunkId] + ".chunk.js";
};